import Component from '@glimmer/component'
import PhosphorIcon from 'teacher-ui-client/components/phosphor-icon'
import { action } from '@ember/object'
import { BookLibraryCollectionSelect } from 'teacher-ui-client/components/book-library/collection-select'
import { t } from 'ember-intl'
import { on } from '@ember/modifier'
import type BookLibraryCollection from 'teacher-ui-client/models/book-library/collection'
import PopoverStandardDropdown from '@blakeelearning/popovers/components/popover/dropdowns/standard'

interface Args {
  collections: BookLibraryCollection[]
  bookId: string
  removeFromCollectionAction: (collection?: BookLibraryCollection) => void
  addToCollectionAction: (collection?: BookLibraryCollection) => void

  bookTitle: string
  onCreateCollection: (collection: BookLibraryCollection) => void
}

interface Signature {
  Element: HTMLDivElement
  Args: Args
}

export class BookLibraryBookCardHeader extends Component<Signature> {
  get favouriteCollection() {
    const { collections = [] } = this.args
    return collections.find((collection) => collection.isFavourite)
  }

  get collectionsWithBook(): BookLibraryCollection[] {
    return this.args.collections.filter((collection) => collection.bookIds?.includes(this.args.bookId))
  }

  get isBookFavourited() {
    const { bookId } = this.args
    return this.favouriteCollection?.bookIds?.includes(bookId)
  }

  @action
  toggleFavourite() {
    if (this.isBookFavourited) {
      this.args.removeFromCollectionAction?.(this.favouriteCollection)
    } else {
      this.args.addToCollectionAction?.(this.favouriteCollection)
    }
  }

  <template>
    <div ...attributes>
      <PopoverStandardDropdown @contentX="auto-right" as |dropdown _status actions|>
        <button
          type="button"
          class="text-oceany-blue-350 mr-2"
          aria-label={{t "bookLibrary.collection.addTo"}}
          {{dropdown.makeTrigger}}
        >
          <PhosphorIcon @icon="phosphor-plus-bold" />
        </button>
        <dropdown.content>
          <BookLibraryCollectionSelect
            @title={{@bookTitle}}
            @collections={{@collections}}
            @collectionsWithBook={{this.collectionsWithBook}}
            @onCreate={{@onCreateCollection}}
            @onSelect={{@addToCollectionAction}}
            @closeAction={{actions.close}}
          />
        </dropdown.content>
      </PopoverStandardDropdown>
      {{#if this.favouriteCollection}}
        <button
          type="button"
          class="text-oceany-blue-350"
          aria-label={{t "bookLibrary.favourites.addTo"}}
          {{on "click" this.toggleFavourite}}
        >
          <PhosphorIcon @icon={{if this.isBookFavourited "phosphor-heart-fill" "phosphor-heart-bold"}} />
        </button>
      {{/if}}
    </div>
  </template>
}

export default BookLibraryBookCardHeader
